<header class="header">
  <a class="home-link" routerLink="/">
    <img class="logo" id="BueneHuberLogo" src="../assets/images/logo_buene_huber_kunst.svg" />
  </a>
</header>

<router-outlet></router-outlet>

<div toastContainer></div>